<template>
  <div id="PayRecordList">
    <PaymentList />
  </div>
</template>
<script>
import PaymentList from '@/components/payment/PaymentList';
export default {
  name: 'PayRecordList',
  components: {
    PaymentList
  }
};
</script>
<style lang="less" scoped>
</style>
